/**
 * The letters a placeholder avatar shows when a person has no image.
 *
 * ONE source for all three surfaces (extension sidebar, dashboard, team
 * review). Decided 2026-09-02 (Emily: two initials everywhere) after the
 * same person rendered "H" in the extension and "HU" in the team-review
 * drawer: each surface had computed its own glyph. Sibling of avatarSlot /
 * AVATAR_PALETTE in ./avatarColor.ts, which single-source the COLOUR; the
 * avatar-palette gate's initials leg refuses a surface that computes its
 * own again.
 *
 * Rule: first letter of the first word plus first letter of the last word,
 * uppercased; a single word gives one letter; nothing to draw from gives "?".
 */
export function avatarInitials(name) {
    const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0)
        return '?';
    if (parts.length === 1)
        return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}
//# sourceMappingURL=avatarInitials.js.map